import { Box } from '@mui/material';
import { dialogSx } from './styles';

export default function Image ({ url, onClose }: { url: string; onClose: () => void; }) {
  return (
    <Box sx={dialogSx}>
      <div className="wrapper">
        <div className="controller">
          <i className="bi bi-x" onClick={onClose} />
        </div>
        <div className="content">
          <img src={url} alt="img" />
        </div>
      </div>
    </Box>
  );
}
